import { CustomerProfile } from '../types'
import { apiFetchJson } from '@/lib/api-client'

/** Fetch customer profile. GET /api/v1/web/customer/profile */
export async function getCustomerProfile(): Promise<CustomerProfile> {
  const json = await apiFetchJson('/api/v1/web/customer/profile', {
    cache: 'no-store',
  })
  return (json.data?.user || json.data) as CustomerProfile
}

/** Update customer profile. PUT/POST /api/v1/web/customer/profile */
export async function updateCustomerProfile(
  payload: Partial<CustomerProfile> | FormData
): Promise<CustomerProfile> {
  const isFormData = payload instanceof FormData
  const json = await apiFetchJson('/api/v1/web/customer/profile', {
    method: isFormData ? 'POST' : 'PUT',
    headers: isFormData ? {} : { 'Content-Type': 'application/json' },
    body: isFormData ? payload : JSON.stringify(payload),
  })
  return (json.data?.user || json.data) as CustomerProfile
}

/** Change customer password. POST /api/v1/auth/change-password */
export async function changeCustomerPassword(payload: {
  current_password: string
  password: string
  password_confirmation: string
}): Promise<{ success: boolean; message: string }> {
  return await apiFetchJson<{ success: boolean; message: string }>('/api/v1/auth/change-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
}
